module.exports = __webpack_public_path__ + "static/media/Politica ambiental CS 2022 Vertical.7799841b.pdf";